var data = [
	{
		layers: [
		],
		modCategory: "DIS",
		modType: "02",
		modPartNumber: "UK-DIS0002",
		modulousId: "DIS|02|UK-DIS0002",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "placeholder door single",
		rvFamilyType: "dis-02_2040x826_01s (2115hx960w s/o)",
		totalThickness: 0,
		size: [
			0.9099999999999983,
			2.089999999999999,
			0.1375
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "WNF",
		modType: "01",
		modPartNumber: "UK-WNF0002",
		modulousId: "WNF|01|UK-WNF0002",
		rgTypes: [
			"Window"
		],
		rvFamilyName: "placeholder window 2",
		rvFamilyType: "wnf-01_800x1600_01s (so 850hx1650w)",
		totalThickness: 0,
		size: [
			1.5999999999999999,
			0.7999999999999978,
			0.1375
		],
		color: "#4b5e82",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DIS",
		modType: "01",
		modPartNumber: "UK-DIS0001",
		modulousId: "DIS|01|UK-DIS0001",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "placeholder door single",
		rvFamilyType: "dis-01_2040x926_01s (2115hx1060w s/o)",
		totalThickness: 0,
		size: [
			1.0099999999999993,
			2.089999999999999,
			0.1375
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DCD",
		modType: "01",
		modulousId: "DCD|01|UK-DCD0003",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "external door casement double",
		rvFamilyType: "1730x2040",
		totalThickness: 0,
		size: [
			1.75,
			2.085,
			0.1375
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DID",
		modType: "02",
		modulousId: "DID|02|UK-DID0001",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "internal double door",
		rvFamilyType: "1210x2040",
		totalThickness: 0,
		size: [
			1.21,
			2.09,
			0.095
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Concrete, Sand/Cement Screed",
				thickness: 0.065
			},
			{
				name: "Metal - Steel",
				thickness: 0.23
			}
		],
		modCategory: "FPA",
		modType: "02",
		modulousId: "FPA|02|",
		rgTypes: [
			"Floor"
		],
		rvFamilyName: "floor",
		rvFamilyType: "module floor cassette_230ste-65scr",
		totalThickness: 0.295,
		size: [
			null,
			0.295,
			null
		],
		color: "#5a6772",
		sizeLock: [
			false,
			true,
			false
		]
	},
	{
		layers: [
		],
		modCategory: "DIS",
		modType: "02",
		modulousId: "DIS|02|UK-DIS0003",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "internal single door",
		rvFamilyType: "726x2040",
		totalThickness: 0,
		size: [
			0.8099999999999989,
			2.09,
			0.095
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DCD",
		modType: "01",
		modulousId: "DCD|01|UK-DCD0002",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "external door casement double",
		rvFamilyType: "1130x2040",
		totalThickness: 0,
		size: [
			1.15,
			2.085,
			0.1375
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	}
];

export { data as default };
//# sourceMappingURL=manual-rv-data.json.js.map
